export default __webpack_public_path__ + "static/media/fest.36f5e088.svg";